<template>
	<div class="main-content" :style='{"color":"#666","padding":"20px 30px 30px","fontSize":"16px"}'>
		<!-- 列表页 -->
		<template v-if="showFlag">
			<el-form class="center-form-pv" :style='{"margin":"0 0 20px","fontSize":"inherit"}' :inline="true" :model="searchForm">
				<el-row :style='{"fontSize":"inherit","display":"block"}' >
					<div :style='{"margin":"0 10px 0 0","fontSize":"inherit","display":"inline-block"}' class="select" label="月份" prop="yuefen">
						<label :style='{"margin":"0 10px 0 0","color":"inherit","display":"inline-block","lineHeight":"40px","fontSize":"inherit","fontWeight":"500","height":"40px"}' class="item-label">月份</label>
						<el-select clearable v-model="searchForm.yuefen" placeholder="请选择月份" >
							<el-option v-for="(item,index) in yuefenOptions" v-bind:key="index" :label="item" :value="item"></el-option>
						</el-select>
					</div>
					<div :style='{"margin":"0 10px 0 0","fontSize":"inherit","display":"inline-block"}' class="select" label="工号" prop="gonghao">
						<label :style='{"margin":"0 10px 0 0","color":"inherit","display":"inline-block","lineHeight":"40px","fontSize":"inherit","fontWeight":"500","height":"40px"}' class="item-label">工号</label>
						<el-select clearable v-model="searchForm.gonghao" placeholder="请选择工号" >
							<el-option v-for="(item,index) in gonghaoOptions" v-bind:key="index" :label="item" :value="item"></el-option>
						</el-select>
					</div>
					<div :style='{"margin":"0 10px 0 0","fontSize":"inherit","display":"inline-block"}'>
						<label :style='{"margin":"0 10px 0 0","color":"inherit","display":"inline-block","lineHeight":"40px","fontSize":"inherit","fontWeight":"500","height":"40px"}' class="item-label">姓名</label>
						<el-input v-model="searchForm.xingming" placeholder="姓名" @keydown.enter.native="search()" clearable></el-input>
					</div>
					<el-button class="search" type="success" @click="search()">
						<span class="icon iconfont icon-yanziwancheng" :style='{"margin":"0 2px","fontSize":"inherit","color":"#fff","height":"40px"}'></span>
						搜索
					</el-button>
				</el-row>

				<el-row class="actions" :style='{"flexWrap":"wrap","margin":"20px 0","display":"flex"}'>
					<el-button class="add" v-if="isAuth('yuangongShebao','新增')" type="success" @click="addOrUpdateHandler()">
						<span class="icon iconfont icon-kaitongfuwu" :style='{"margin":"0 2px","fontSize":"inherit","color":"#fff","height":"40px"}'></span>
						新增
					</el-button>
					<el-button class="del" v-if="isAuth('yuangongShebao','删除')" :disabled="dataListSelections.length?false:true" type="danger" @click="deleteHandler()">
						<span class="icon iconfont icon-guanbi1" :style='{"margin":"0 2px","fontSize":"inherit","color":"#fff","height":"40px"}'></span>
						删除
					</el-button>
					<el-upload
						class="upload-demo"
						:action="$base.url + 'yuangongshebao/importExcel'"
						:headers="{ token: $storage.get('Token') }"
						:on-success="importSuccess"
						:on-error="importError"
						:show-file-list="false"
						accept=".xls,.xlsx"
						style="display: inline-block; margin-left: 10px;">
						<el-button class="add" type="success">
							<span class="icon iconfont icon-kaitongfuwu" :style='{"margin":"0 2px","fontSize":"inherit","color":"#fff","height":"40px"}'></span>
							批量导入
						</el-button>
					</el-upload>
				</el-row>
			</el-form>
			<div :style='{"width":"100%","padding":"0","background":"none"}'>
				<el-table class="tables"
					:stripe='false'
					:style='{"padding":"0","borderColor":"#eee","color":"inherit","borderWidth":"1px 0 0 1px","background":"#fff","width":"100%","fontSize":"inherit","borderStyle":"solid"}' 
					:border='true'
					v-if="isAuth('yuangongShebao','查看')"
					:data="dataList"
					v-loading="dataListLoading"
				@selection-change="selectionChangeHandler">
					<el-table-column :resizable='true' type="selection" align="center" width="50"></el-table-column>
					<el-table-column :resizable='true' :sortable='true' label="序号" type="index" width="50" />
					<el-table-column :resizable='true' :sortable='true'  
						prop="yuefen"
						label="月份">
						<template slot-scope="scope">
							{{scope.row.yuefen}}
						</template>
					</el-table-column>
					<el-table-column :resizable='true' :sortable='true'  
						prop="gonghao"
						label="工号">
						<template slot-scope="scope">
							{{scope.row.gonghao}}
						</template>
					</el-table-column>
					<el-table-column :resizable='true' :sortable='true'  
						prop="xingming"
						label="姓名">
						<template slot-scope="scope">
							{{scope.row.xingming}}
						</template>
					</el-table-column>
					<el-table-column :resizable='true' :sortable='true'  
						prop="yanglaoGeren"
						label="养老（个人）">
						<template slot-scope="scope">
							{{scope.row.yanglaoGeren}}
						</template>
					</el-table-column>
					<el-table-column :resizable='true' :sortable='true'  
						prop="yiliaoGeren"
						label="医疗（个人）">
						<template slot-scope="scope">
							{{scope.row.yiliaoGeren}}
						</template>
					</el-table-column>
					<el-table-column :resizable='true' :sortable='true'  
						prop="gongjijinGeren"
						label="公积金（个人）">
						<template slot-scope="scope">
							{{scope.row.gongjijinGeren}}
						</template>
					</el-table-column>
					<el-table-column :resizable='true' :sortable='true'  
						prop="gerenHeji"
						label="个人合计">
						<template slot-scope="scope">
							<span style="color:#409eff;font-weight:bold">{{scope.row.gerenHeji}}</span>
						</template>
					</el-table-column>
					<el-table-column :resizable='true' :sortable='true'  
						prop="gongsiHeji"
						label="公司合计">
						<template slot-scope="scope">
							<span style="color:#56B2C6;font-weight:bold">{{scope.row.gongsiHeji}}</span>
						</template>
					</el-table-column>
					<el-table-column :resizable='true' :sortable='true'  
						prop="jiaonaRiqi"
						label="缴纳日期">
						<template slot-scope="scope">
							{{scope.row.jiaonaRiqi}}
						</template>
					</el-table-column>
					<el-table-column width="300" label="操作">
						<template slot-scope="scope">
							<el-button class="view" v-if=" isAuth('yuangongShebao','查看')" type="success" @click="addOrUpdateHandler(scope.row.id,'info')">
								<span class="icon iconfont icon-dagou" :style='{"margin":"0 2px","fontSize":"inherit","color":"inherit","height":"40px"}'></span>
								查看
							</el-button>
							<el-button class="edit" v-if=" isAuth('yuangongShebao','修改') " type="success" @click="addOrUpdateHandler(scope.row.id)">
								<span class="icon iconfont icon-bianji" :style='{"margin":"0 2px","fontSize":"inherit","color":"inherit","height":"40px"}'></span>
								修改
							</el-button>
							<el-button class="del" v-if=" isAuth('yuangongShebao','删除')" type="danger" @click="deleteHandler(scope.row.id)">
								<span class="icon iconfont icon-guanbi1" :style='{"margin":"0 2px","fontSize":"inherit","color":"inherit","height":"40px"}'></span>
								删除
							</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<el-pagination
				@size-change="sizeChangeHandle"
				@current-change="currentChangeHandle"
				:current-page="pageIndex"
				:page-sizes="[10, 20, 50, 100]"
				:page-size="pageSize"
				:total="totalPage"
				:layout="layouts.join()"
				prev-text="上一页"
				next-text="下一页 "
				:hide-on-single-page="false"
				:style='{"padding":"0","margin":"20px 0 0","whiteSpace":"nowrap","color":"inherit","width":"100%","fontSize":"inherit","fontWeight":"500"}'
			></el-pagination>
		</template>

		<!-- 添加/修改页面 -->
		<add-or-update v-if="!showFlag" :parent="this" ref="addOrUpdate"></add-or-update>
	</div>
</template>

<script>
import AddOrUpdate from "./add-or-update";
export default {
	data() {
		return {
			searchForm: {
				key: ""
			},
			dataList: [],
			pageIndex: 1,
			pageSize: 10,
			totalPage: 0,
			dataListLoading: false,
			dataListSelections: [],
			showFlag: true,
			layouts: ['prev', 'pager', 'next', 'jumper', '->', 'sizes', 'total'],
			yuefenOptions: [],
			gonghaoOptions: []
		}
	},
	components: {
		AddOrUpdate
	},
	activated() {
		this.showFlag = true;
		this.getDataList();
	},
	mounted() {
		this.getDataList();
		this.getYuefenOptions();
		this.getGonghaoOptions();
	},
	methods: {
		search() {
			this.pageIndex = 1;
			this.getDataList();
		},
	// 获取月份选项
	async getYuefenOptions() {
		this.$http({
			url: "yuangongshebao/page",
			method: "get",
			params: {
				page: 1,
				limit: 100
			}
		}).then(({ data }) => {
				if (data && data.code === 0) {
					this.yuefenOptions = [...new Set(data.data.list.map(item => item.yuefen))].filter(item => item);
				}
			})
		},
	// 获取工号选项
	async getGonghaoOptions() {
		this.$http({
			url: "yuangongshebao/page",
			method: "get",
			params: {
				page: 1,
				limit: 100
			}
		}).then(({ data }) => {
				if (data && data.code === 0) {
					this.gonghaoOptions = [...new Set(data.data.list.map(item => item.gonghao))].filter(item => item);
				}
			})
		},
		// 获取数据列表
		getDataList() {
			this.dataListLoading = true
			let params = {
				page: this.pageIndex,
				limit: this.pageSize,
				sort: 'id'
			}
			if(this.searchForm.yuefen) params.yuefen = this.searchForm.yuefen;
			if(this.searchForm.gonghao) params.gonghao = this.searchForm.gonghao;
			if(this.searchForm.xingming) params.xingming = '%' + this.searchForm.xingming + '%';
			
		this.$http({
			url: "yuangongshebao/page",
			method: "get",
			params: params
		}).then(({ data }) => {
				if (data && data.code === 0) {
					this.dataList = data.data.list
					this.totalPage = data.data.total
				} else {
					this.dataList = []
					this.totalPage = 0
				}
				this.dataListLoading = false
			})
		},
		// 每页数
		sizeChangeHandle(val) {
			this.pageSize = val
			this.pageIndex = 1
			this.getDataList()
		},
		// 当前页
		currentChangeHandle(val) {
			this.pageIndex = val
			this.getDataList()
		},
		// 多选
		selectionChangeHandler(val) {
			this.dataListSelections = val
		},
		// 新增 / 修改
		addOrUpdateHandler(id, type) {
			this.showFlag = false
			this.$nextTick(() => {
				this.$refs.addOrUpdate.init(id, type)
			})
		},
		// 导入成功
		importSuccess(response, file, fileList) {
			if (response && response.code === 0) {
				this.$message({
					message: response.msg || '导入成功',
					type: 'success',
					duration: 3000
				});
				this.getDataList();
			} else {
				this.$message.error(response.msg || '导入失败');
			}
		},
		// 导入失败
		importError(err, file, fileList) {
			this.$message.error('导入失败，请检查文件格式');
		},
		// 删除
		deleteHandler(id) {
			var ids = id ? [id] : this.dataListSelections.map(item => {
				return item.id
			})
			this.$confirm(`确定删除所选的${ids.length}条数据?`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
		}).then(() => {
			this.$http({
				url: "yuangongshebao/delete",
				method: "post",
				data: ids
			}).then(({ data }) => {
					if (data && data.code === 0) {
						this.$message({
							message: '删除成功',
							type: 'success',
							duration: 1500
						})
						this.getDataList()
					} else {
						this.$message.error(data.msg)
					}
				})
			}).catch(() => {})
		}
	}
}
</script>

<style lang="scss" scoped>
.center-form-pv ::v-deep .el-input__inner{
	background: rgba(255, 255, 255, 1);
	border-radius: 0px;
	padding: 0 12px;
	box-shadow: 0 0 0px rgba(75,123,219,.5);
	outline: none;
	color: #333;
	width: auto;
	border-width: 1px;
	border-style: solid;
	border-color: rgba(161,161,161,1);
	height: 40px;
}

.center-form-pv ::v-deep .el-select .el-input__inner {
	background: rgba(255, 255, 255, 1);
	border-radius: 0px;
	padding: 0 12px;
	box-shadow: 0 0 0px rgba(75,123,219,.5);
	outline: none;
	color: #333;
	width: 120px;
	border-width: 1px;
	border-style: solid;
	border-color: rgba(161,161,161,1);
	height: 40px;
}

/* 覆盖Element UI的success绿色为青蓝色 #56B2C6 */
.el-button--success {
    background-color: #56B2C6 !important;
    border-color: #56B2C6 !important;
}

.el-button--success:hover,
.el-button--success:focus {
    background-color: #68bdd2 !important;
    border-color: #68bdd2 !important;
}

.el-tag--success {
    background-color: rgba(86,178,198,.1) !important;
    border-color: rgba(86,178,198,.2) !important;
    color: #56B2C6 !important;
}

/* 增加表格行高，让按钮不拥挤 */
::v-deep .el-table__row {
    height: 70px;
}

::v-deep .el-table td.el-table__cell {
    padding: 16px 0;
}

::v-deep .el-table__body td.el-table__cell .cell {
    line-height: 38px;
}

/* 调整操作列按钮间距 */
::v-deep .el-table__body td.el-table__cell .el-button {
    margin: 4px 3px;
}

</style>
